import React from "react";
import { Link } from "react-router-dom";
import { EyeIcon, LockClosedIcon, ShieldCheckIcon, ArrowUturnLeftIcon } from "@heroicons/react/24/outline";
import Section from "./Section";

const ITEMS = [
  // "Never reads your code" replaced "Read-only access" 2026-08-27. Two reasons:
  // it's the sharper claim under the current positioning (we read filenames and
  // line counts, never the diff), and it stays true if the App ever gains
  // `Pull requests: Write` to request reviewers on GitHub — which would make a
  // blanket "read-only access" label false.
  { icon: EyeIcon, label: "Never reads your code" },
  { icon: LockClosedIcon, label: "Never writes to your code" },
  { icon: ShieldCheckIcon, label: "No GitHub credentials stored, ever" },
  { icon: ArrowUturnLeftIcon, label: "Uninstall anytime" },
];

/**
 * Real claims, not aspirational ones — verified against the GitHub App
 * model in CLAUDE.md: installation tokens are minted on demand and expire
 * in an hour, never persisted (crypto-utils.mjs and its stored-token column
 * were deleted in the GitHub App migration, PR #13).
 */
export default function SecurityStrip() {
  return (
    <Section className="!py-16">
      <div className="flex flex-col items-center gap-10">
        <div className="grid w-full gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {ITEMS.map((item) => (
            <div key={item.label} className="flex items-center gap-3">
              <item.icon className="h-5 w-5 shrink-0 text-rf-accent" aria-hidden="true" />
              <span className="text-sm text-rf-text-primary">{item.label}</span>
            </div>
          ))}
        </div>
        <Link
          to="/security"
          className="cursor-pointer text-sm font-medium text-rf-accent-blue transition-colors duration-200 hover:text-rf-text-primary"
        >
          Read more about how we handle access →
        </Link>
      </div>
    </Section>
  );
}
